import app from '$$app';
import InlineEditors from '../../controllers/inlineEditors';
import massChangeContextMenu from '../../grid/massChangeContextMenu';
import massChangeSelectMenu from '../../grid/massChangeSelectMenu';
import webixContextMenu from '../../grid/webixContextMenu';
import keyboardNavigation from '../../grid/keyboardNavigation';

export default instance => {
  const previousScrollState = {
    y: 0,
    x: 0,
  };

  instance.attachEvent('onGanttScroll', () => {
    const { y: currentY, x: currentX } = instance.getScrollState();
    const isVerticalScroll = previousScrollState.y !== currentY;
    const isHorizontalScroll = previousScrollState.x !== currentX;

    if (isVerticalScroll) {
      previousScrollState.y = currentY;

      if (InlineEditors.getState().columnName !== 'text' || !keyboardNavigation.creatingTask) {
        InlineEditors.hide();
      }
    }

    if (isHorizontalScroll) {
      previousScrollState.x = currentX;
    }

    if (isVerticalScroll || isHorizontalScroll) {
      app.trigger('hideResourcesListForTask');
      app.trigger('hideResourcesPreviewListForTask');
      app.trigger('tooltip:hide');

      massChangeContextMenu.hide();
      massChangeSelectMenu.hide();
      webixContextMenu.hide();
    }
  });
};
